export enum AlertType {
    SUCCESS = 'success',
    WARNING = 'warning',
    CRITICAL = 'critical',
    NEUTRAL = 'neutral'
}

export interface AlertMessage {
    id: string;
    message: string;
    type: AlertType;
    duration?: number;
}

export interface CommonState {
    alert: {
        messages: AlertMessage[];
    };
}
